<template>
  <CCol>
    <!-- <CRow>
      <CCol sm="12" class="text-white">
        <h1 class="mb-5">{{ $t('auth.confirmRegister.aside.header1.security-check') }}</h1>
        <p class="font-xl text-gray-700">
          {{ $t('auth.confirmRegister.aside.text.adictional-security') }}
          
        </p>

        <p class="font-xl text-gray-700">
          {{ $t('auth.confirmRegister.aside.text.two-factor-authentication') }}
          
        </p>
        <p class="font-xl text-gray-700">
          {{ $t('auth.confirmRegister.aside.text.two-factor-authentication-info') }}
          
        </p>
      </CCol>
    </CRow>
    <Steps :steps="3" :stepActive="3" :progress="140"/> -->
  </CCol>
</template>

<script>
import Steps from '@/views/auth/components/aside/Steps.vue'

export default {
  name: 'asideConfirm',
  components: {
    Steps,
  },
}
</script>

<style></style>
